import { useQuery } from "react-query";
import type { UseQueryOptions } from "react-query/types/react/types";
import { UTILS_API_PATH } from "src/confs/APIConfig";
import { useApiGet } from "src/shared/actions/FetchActions";
import type { Region } from "src/shared/objects/Region";

export const useRegions = (
  countryCode: string,
  options?: UseQueryOptions<Region[], unknown, Region[], ["regions", string]>,
) => {
  const apiGet = useApiGet();
  return useQuery(
    ["regions", countryCode],
    async () => {
      const { data } = await apiGet<Region[]>(
        `${UTILS_API_PATH}/regions/${countryCode}`,
      );
      return data;
    },
    options,
  );
};
